import React from "react";
import { Button } from "@telia/teddy";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import { submitOrder } from "../../../state/actions/onboardingActions";
import { ONBOARDING_SUBMIT_ORDER } from "../../../state/actionTypes";

interface StateProps {
    isSubmittingOrder: boolean;
}

type SummaryContinueButtonProps = StateProps;

const SummaryContinueButton: React.FC<SummaryContinueButtonProps> = ({ isSubmittingOrder }) => {
    const dispatch = useDispatch();
    return (
        <Button
            className="onboarding-b2b__registerbutton"
            onClick={() => {
                dispatch(submitOrder());
            }}
            loading={isSubmittingOrder}
        >
            Fullfør registering
        </Button>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    isSubmittingOrder: LOADING_SELECTORS.isTypeLoading(state, ONBOARDING_SUBMIT_ORDER),
});

export default connect(mapStateToProps)(SummaryContinueButton);
